<div style="overflow:hidden !important" id="popupbody">
  <!--<ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
    <li class="nav-item" id="divconfig"><a data-toggle="tab" href="#divConfig" class="nav-link active">Config</a></li>
    <li class="nav-item"><a data-toggle="tab" href="#divscoreconfig" class="nav-link">Score Config</a></li>-->
  <!--<li class="nav-item" id="divconfigCategory"><a data-toggle="tab" href="#divConfigCategory" class="nav-link">Config Category</a></li>-->
  <!--</ul>-->
  <br />
  <div class="tab-content" id="CC3ConfigtabContent">

    <div class="tab-pane active" id="divConfig">

      <button type="button" (click)="ShowConfigList()" id="btnConfigAddNew" style="display:none;">Add</button>
      <table #dataTableConfig class="display" style="width:100%"></table>

      <div id="btnPopupartDetail" class="modal" style="position: fixed !important;display:none">
        <div class="modal-dialog modal-xl custome-modal">
          <div class="modal-content" id="modal_contentArt">
            <div class="modal-header" style="text-align:center">
              <h4 class="modal-title"> {{title}} </h4>
              <button type="button" class="close" data-dismiss="modal" (click)="hideConfig()">×</button>
            </div>

            <div class="modal-body" id="divPopupartBody">

              <div class="row">
                <button type="button" id="btnJrlConfigList" (click)="GetConfigJournalsdetails()" style="display:none">Get</button>
                <div class="col-sm-4">
                  <div class="row">
                    <div class="col-sm-12" id="ScoreConfigRemarks">
                      <label for="txtFormulaName "> Formula Name</label><em>*</em>
                      <input type="text" class="form-control" id="txtFormulaName" autocomplete="off" />
                    </div>&nbsp;
                    <div class="col-sm-12">
                      <label for="ddlConfigPublisher">Publisher</label><em>*</em>
                      <select id="ddlConfigPublisher" class="form-control" onchange="$('#btnJrlConfigList').trigger('click');">
                        <option value="0">Select</option>
                        <option *ngFor="let item of PublisherList" value={{item.ID}}>
                          {{item.PublisherCode}}
                        </option>
                      </select>
                    </div>&nbsp;
                    <div class="col-sm-12">
                      <label for="ddlConfigJournal">Journal</label>
                      <select id="ddlConfigJournal" class="form-control">
                        <option value="0">Select</option>
                        <option *ngFor="let item of journalListConfig" value={{item.ID}}>
                          {{item.Acronym}}
                        </option>
                      </select>
                    </div>&nbsp;
                    <div class="col-sm-12">
                      <label>Words Division</label><em>*</em>
                      <input id="TxtWordsDivision" type="number" min="0" max="1000" class="form-control" autocomplete="off" />
                    </div>&nbsp;
                    <div class="col-sm-12" id="ScoreConfigRemarks">
                      <label for="txtRemarks "> Remarks</label>
                      <input type="text" class="form-control" id="txtRemarks" autocomplete="off" />
                    </div>
                  </div>
                </div>

                <div class="col-sm-8">

                  <button type="button" id="btnDeleteCategory" (click)="deleteConfigCategory()" style="display:none">Delete Budget</button>

                  <span id="spUpdateConfig" class="CategoryAddbtn" (click)="ShowConfigCategory()" style="display:none"></span>
                  <div class="col-sm-12">
                    <div style="float: right; padding-right: 10px;">
                      <span id="spAddConfig" title="Add Config" class="btn btn-outline-info waves-effect waves-light Addbtn"
                            (click)="ShowConfigCategory(0)"><i class="fa fa-plus-square" aria-hidden="true"></i></span>
                    </div>
                    <div class="form-group col tblRightsList fixTableHead">
                      <table id="tblAddCC3Config" class="table" Style="width:100%">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th style="display:none">Id</th>
                            <th>Category</th>
                            <th>Applicable Summary</th>
                            <th>Weightage</th>
                            <th>Remarks</th>
                            <th style='text-align: center'>Actions</th>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                  </div>

                  <div class="modal" id="myModalConfig" [style.display]="showConfigModal ? 'block' : 'none'">
                    <div class="modal-dialog modal-lg">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h4 class="modal-title">{{titles}}</h4>
                          <button type="button" class="close" data-dismiss="modal" (click)="hideCategory()">x</button>
                        </div>
                        <div class="modal-body">
                          <div class="form-group">
                            <div class="col-12">
                              <div class="row">
                                <div class="col-sm-4" id="Category">
                                  <label>Category</label>
                                  <select class="form-control" id="ddlCategory">
                                    <option value="Select">Select</option>
                                    <option value="Grammar">Grammar</option>
                                    <option value="Punctuation">Punctuation</option>
                                    <option value="Spelling">Spelling</option>
                                    <option value="Consistency">Consistency</option>
                                    <option value="Fluency">Fluency</option>
                                    <option value="Conventions">Conventions</option>
                                  </select>

                                </div>
                                <div class="col-sm-4" id="Aplicablesummary">
                                  <label>Applicable Summary</label>
                                  <select class="form-control" id="ddlApplicabaleSummary">
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                  </select>
                                </div>
                                <div class="col-sm-4">
                                  <label>Weightage</label>
                                  <select class="form-control" id="ddlWeightage">
                                    <option value="0">Select</option>
                                    <option value="2">50%</option>
                                    <option value="1">100%</option>
                                  </select>
                                </div>
                              </div>&nbsp;
                              <div class="col-sm-12" id="ConfigRemark">
                                <label> Remarks</label>
                                <input type="text" class="form-control" id="txt_Remarks" autocomplete="off" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideCategory()">Close</button>
                          <button type="submit" (click)="UpdateConfigCategoryData()" class="btn btn-outline-success waves-effect waves-light">Update</button>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideConfig()">Close</button>
                <button type="submit" (click)="addUpdateConfig()" class="btn btn-outline-success waves-effect waves-light">{{popupConfigButtonText}}</button>
              </div>
            </div>
            <div id="LoadingImagePopupConfig">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</div>


